import { useCallback } from "react";
import type { RefCallback } from "react";

// Minimal local type to avoid depending on MutableRefObject (some toolchains/linters mark it deprecated)
type MutableArrayRef<T> = { current: (T | null)[] | undefined };

// Hook: returns a stable ref-callback that assigns the given element to refArray.current[index]
export function useIndexedRef<T>(refArray: MutableArrayRef<T>, index: number): RefCallback<T> {
  return useCallback(
    (el: T | null) => {
      if (!refArray.current) refArray.current = [];
      refArray.current[index] = el;
    },
    [refArray, index]
  );
}

export default useIndexedRef;
